const API_BASE = import.meta.env.VITE_API_URL || "https://pod-mockup-api.richfulsmart.workers.dev";

async function fetchApi<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error?.message || "API Error");
  }
  return data.data;
}

export const api = {
  getUploadUrls: (file: File) => fetchApi<{ designId: string; uploadUrls: { original: string; thumbnail: string }; originalUrl: string; thumbnailUrl: string }>("/api/v1/designs/upload", {
    method: "POST",
    body: JSON.stringify({ fileName: file.name, contentType: file.type }),
  }),

  confirmUpload: (body: {
    designId: string;
    name: string;
    width: number;
    height: number;
    format: "png" | "jpg";
    hasTransparency: boolean;
    originalUrl: string;
    thumbnailUrl: string;
  }) => fetchApi<{ id: string }>("/api/v1/designs/confirm", { method: "POST", body: JSON.stringify(body) }),

  getDesign: (id: string) => fetchApi(`/api/v1/designs/${id}`),
  listTemplates: () => fetchApi<any[]>("/api/v1/templates"),
  getTemplate: (id: string) => fetchApi(`/api/v1/templates/${id}`),

  createMockup: (body: {
    designId: string;
    templateId: string;
    variantId?: string;
    posX: number;
    posY: number;
    scale: number;
    rotation: number;
  }) => fetchApi<{ id: string; status: string; cacheKey: string }>("/api/v1/mockups", { method: "POST", body: JSON.stringify(body) }),

  getMockup: (id: string): Promise<any> => fetchApi(`/api/v1/mockups/${id}`),

  createBulkMockups: (body: {
    designId: string;
    items: Array<{
      templateId: string;
      variantId?: string;
      posX: number;
      posY: number;
      scale: number;
      rotation: number;
    }>;
  }) => fetchApi<any>("/api/v1/mockups/bulk", { method: "POST", body: JSON.stringify(body) }),

  createOrder: (body: any) => fetchApi<any>("/api/v1/orders", { method: "POST", body: JSON.stringify(body) }),
};
